import React from "react";
import { formatDate } from "../../util";
import imgSample from "../../../img/sample/sample_farm_2.png";
import imgIcon from "../../../img/logo/bb_logo_192x192.png";
import i18n from "i18next";
import "./BlogArticle.scss";
import { ShareButton } from "../../panels/Share";

export const BlogArticle = ({ post }) => (
  <div className="row justify-content-center">
    <div className="col-12 col-lg-10 no-padding">
      <article className="blog_article_item">
        <header className="blog_hero">
          <img
            className="blog_hero_image d-sm-block"
            src={post.picture_large || imgSample}
            alt={i18n.t("Title")}
          />
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12 ">
                <div className="inner_blog">
                  <div className="blogger_info">
                    <img
                      alt={i18n.t("Author")}
                      className="avatar"
                      src={post.picture_small || imgIcon}
                    />
                    <h2 className="blogger_title">{post.author_title || i18n.t("CropFields")}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ShareButton text={{ subject: i18n.t("Blog"), thisSubject: i18n.t("this blog") }} />
        </header>
        <div className="blog_content">
          <h4>
            <span className="date">{formatDate(post.publish_date)}</span>{" "}
            <span dangerouslySetInnerHTML={{ __html: post.article_title }} />
          </h4>
          <div dangerouslySetInnerHTML={{ __html: post.rendered_content }} />
        </div>
      </article>
    </div>
  </div>
);
